import { MemberType } from "@/enums/mateEnums";

export enum ChestType {
  Normal = 1,
  StandardMember = 2,
  PremiumMember = 3,
  BasicMember = 4,
}

export const memberRarityMap = {
  [MemberType.Free]: "rarity-1",
  [MemberType.Basic]: "rarity-1",
  [MemberType.Standard]: "rarity-2",
  [MemberType.Premium]: "rarity-3",
};

export enum TransactionType {
  Income = 1,
  Expense = 2,
}

export enum PowerCubeTransactionCategory {
  Recharge = 1,
  ADReward = 2,
  ShareReward = 3,
  DrawImage = 4,
  DrawAvatar = 5,
  InpaintImage = 6,
  Chat = 7,
  PublishAdoption = 8,
  AdoptMate = 9,
  AdoptionReward = 10,
  Dispatch = 11,
  JoinDispatch = 12,
  DispatchReward = 13,
  DispatchRefund = 14,
  Wish = 15,
  CompleteModule = 16,
  CompleteMoment = 17,
  CompleteReply = 18,
  CompleteMail = 19,
  CompleteRoleplayAnswer = 20,
  GenerateInteractionRequest = 21,
  GenerateDispatchObjective = 22,
  VoteRanking = 23,
  ConvertTextToSpeech = 24,
  DecomposeEquipment = 25,
  OpenChest = 26,
  PurchaseChest = 27,
  ExtractMemory = 28,
  GenerateTreeHoleComment = 29,
  GenerateSprite = 30,
  GenerateSpriteAnimation = 31,
  MateHouseSessionMessage = 32,
  GenerateSpritePortrait = 33,
  GenerateHouseSessionEvent = 34,
  SpriteGenerationRefund = 35,
  GenerateMate = 36,
  MateGenerationRefund = 37,
  SpritePortraitGenerationRefund = 38,
  GenerateSpriteFullAnimation = 39,
  GenerateSpriteAvatar = 40,
  SpriteAvatarGenerationRefund = 41,
  MemberSubscriptionGift = 42,
  WishRefund = 43,
  UserTaskReward = 44,
}
